export interface ISVGIcon {
  IconName: string,
  size?: string,
  fill?: string
}

export function Icon(props: ISVGIcon) {
  //if (props.fill == null)     props.fill = '#0c64c5'
  let iconsvg = null;
  switch (props.IconName) {
    case "ChevronDown":
      iconsvg =
        <svg xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={props.size}
          height={props.size}
          fill={props.fill}>
          <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
        </svg>
      break;
    case "Robot":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path
            d="M320 0c17.7 0 32 14.3 32 32v64h120c39.8 0 72 32.2 72 72v272c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h120V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zM264 256a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224h16v192H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16V224h16z"
          />
        </svg>
      break;
    case "Tablet":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path
            d="M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm256 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM384 64H64v320h320V64z"
          />
        </svg>
      break;
    case "Markup":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path
            d="M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
          />
        </svg>
      break;
    case "PenNib":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path
            d="m368.4 18.3-55.7 55.8 125.2 125.2 55.7-55.7c21.9-21.9 21.9-57.3 0-79.2l-46-46.1c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8-144.1 43.2c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4l153.6-153.5c-3-6.3-4.7-13.3-4.7-20.7 0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
          />
        </svg>
      break;
    case "Cloud":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path
            d="M0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4 4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336z"
          />
        </svg>
      break;
    case "Chart":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={props.size}
          height={props.size}
          fill={props.fill}

        >
          <path
            d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l89.4-89.3 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
          />
        </svg>
      break;
    case "Envelope":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path
            d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l217.6-163.2c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48H48zM0 176v208c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V176L294.4 339.2a63.9 63.9 0 0 1-76.8 0L0 176z"
          />
        </svg>
      break;
    case "Location":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path
            d="M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
          />
        </svg>
      break;

    case "Microchip":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path
          d="M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24zm-16 104h192c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160v192h192V160z"
        />
      </svg>
      break;
    case "Handshake":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path
          d="M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2l-78.1-78c-21.9-21.9-57.3-21.9-79.2 0l-40.1 40.1c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64h-.4v120c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h160c44.2 0 80 35.8 80 80v8zm-208-56v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2l-16.5 57.6-73.2 73.2c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8.1 2.7.1h160c26.5 0 48-21.5 48-48 0-5.6-1-11-2.7-16h2.7c26.5 0 48-21.5 48-48 0-12.8-5-24.4-13.2-33 25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8H336z"
        />
      </svg>
      break;

    case "PeopleGroup":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path
          d="M72 88a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-8 157.7c-10 11.2-16 26.1-16 42.3s6 31.1 16 42.3v-84.6zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-26.8C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416v-21.5c20-24.7 32-56.2 32-90.5 0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112 0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm120 157.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-80 272c0 16.2 6 31 16 42.3v-84.6c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zm64 42.3c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-42.8c-37.8-18-64-56.5-64-101.2 0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
        />
      </svg>
      break;
    case "UserTie":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path
          d="M224 256a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm-14.9 103.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3 70.1 17.6 121.9 81 121.9 156.4 0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8.7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4 8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"
        />
      </svg>
      break;
    case "Close":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path
          d="M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm111 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        />
      </svg>
      break;
    case "Humburg":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path
          d="M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32z"
        />
      </svg>
      break;
    case "Phone":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448 18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368c-70.4-33.3-127.4-90.3-160.7-160.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
        />
      </svg>
      break;
    case "ControlledOutsourcing":
      iconsvg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-67 69 120 120"
        xmlSpace="preserve"
        width={props.size}
        height={props.size}
        fill={props.fill}
      >
        <path d="M-8.2 113c11.3 0 20.5-9.2 20.5-20.5S3.1 72-8.2 72s-20.5 9.2-20.5 20.5S-19.5 113-8.2 113zM-23 81.7c.5-.3.9-.9 1.8-.7 0 .2.1.4.1.5.4-.1.6-.4.7-.9.6.6 0 1.6-.2 2.1 2.1.3 1.4-1.2 1.6-2.4.2-1.1 2.1-1.6 1.8-2.9-.6-.1-1.2 0-1.7.3v-.2c.7-.5 1.3-.9 2-1.3 1.2 0 1.4 1.1.2 1.5-.4 1.4 1.2.6 1.6.4.5-.2.4-.3 1.1-.4.5-.1 1 .1 1.5-.2-.5 1.5-2.3 1.5-3.1 2.6-1.2 1.7 1.8 1.2 2.8.4.6-.5.8-1.3 1.3-1.7.7-.5 1.6-.1 1.8-1 0-.2-.6-1.4-.6-1.6-.4-.9-.8-.7 0-1.7h-.6v-.2c1-.2 2-.3 3-.3.9 0 1.9.1 2.8.2.7.4 1.2 1.1 1.8 1.7 1.8 1.8-.9 1.2-.7 2.5.1.7 1 .4.4 1.5-.4.6-1.2.7-1.1 1.5-1.4.2-2.3-.9-3.7-.4-.7.3-1.5.7-1.6 1.4-.2 1.2.7 1.1 1.4 1.6.6.5.5.5.4 1.6-.2.9-.1 1.3-1 1.7-.4.2-1 .1-1.4.3-.1.1-.2.6-.4.8-.5.4-2 .2-1.6 1.3.5.1.9-.2 1.4-.2 1.1 0 .5.2 1.2.7.8.6 1.9.7 2.8 1.1.5.2.8.5 1.3.5.2.9-.6 1.1-1.3 1.3-1.1.3-1.4.2-2-.7-.8-1.2-.9-.8-2.4-1-.6 0-2.3-.2-2.7-.7-.5-.6.1-1.5.6-1.9.9-.6 1.1-.5 1.6-1.3.6-.9.6-.6 1.5-1 .7-.3 1.3-.8 1.3-1.7-.5-.1-.7-.5-.7-1l-.9-.3c.1.4 1.2 3.3-.4 2.5-.6-.3 0-3.1-1.7-2.6.1.8-.2.9-.8 1.4-.8.7-.9 0-.6 1.1.2.7.7.6.4 1.5-.2.6-1 .6-.2 1.4-.4.1-.8 0-1.1-.1-.9.9-.4 1.2-.8 2.4s-2 1.6-2.8 2.5c-1.4 1.5-1.8 5.4.2 6.5 1.6.9 3.2 0 4.7.6 1.1.4 1.4 1 1.5 2 .2 1.2 1.2 1.8 1.3 3.2.1 1.2 0 1.9.8 2.8.4.4 1.2 1.2 1.7 1.4.9.4 1.2 0 2-.4.3-.1.7-.2 1-.3.7-.4.4-.1.8-.7.4-.5.5-1.2 1.1-1.8.7-.7.9-.9 1.2-1.8.3-.7.3-1.4.6-2.1.3-.7 1-1.3 1.4-1.9.4-.6.5-1.5 1.1-2-.6 0-1.8.3-2.4.1-.7-.2-.9-1-1.3-1.6-.8-1-2.1-2.6-2.1-4 .5-.1 2 2.6 2.3 3.1 1.1 1.6 1.8 1.1 3.1.5.7-.3 3.4-1.9 2.3-2.8-.7-.6-3.7 1-3.4-.8 1.2 0 2.6-.1 3.8-.4.6-.1 1.1-.5 1.6-.4.1 0 .4.5.5.6.3.1.9 0 1.2 0 .1.9 1.2 3.3 2.3 3 .1-1.9 0-3.6.5-5.4.5-.1.9 0 1.4 0v1.4c0 10.2-8.3 18.5-18.4 18.5s-18.4-8.3-18.4-18.4c-.1-4 1.2-7.8 3.5-10.8zm38.7 54c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm-1.8 27.9c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM10 175.3v13.9H3.9v-12.3c0-.5-.4-1-1-1-.5 0-1 .4-1 1v12.3h-19.8v-12.3c0-.6-.4-1-1-1-.5 0-1 .4-1 1v12.3H-26v-14c0-5.7 3.4-10.2 8.9-10.2h18c5.8.1 9.2 4.6 9.1 10.3zm-6.7-31.6c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.5 8-8 8zm31.6 3.9c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.5-8 8-8zM53 175.3v13.9h-6.1v-12.3c0-.5-.4-1-1-1-.5 0-1 .4-1 1v12.3H25.2v-12.3c0-.6-.4-1-1-1-.5 0-1 .4-1 1v12.3h-6.1v-14c0-5.7 3.4-10.2 8.9-10.2h18c5.6 0 9.1 4.5 9 10.3zm-110-19.7c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm25.8 19.7v13.9h-6.1v-12.3c0-.5-.4-1-1-1-.5 0-1 .4-1 1v12.3H-59v-12.3c0-.6-.4-1-1-1-.5 0-1 .4-1 1v12.3h-6v-14c0-5.7 3.4-10.2 8.9-10.2h18c5.5 0 9 4.5 8.9 10.3zm15.3-19.7c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm-30.9-19.9c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm29.7 8c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm-10.8 19.9c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" />
      </svg>
      break;
    case "AccesstoTalent":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 240"
          xmlSpace="preserve"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path d="M206,2c-26.467,0-48,21.533-48,48s21.533,48,48,48s48-21.533,48-48S232.467,2,206,2z M241.499,31.6H228.51 c-1.069-4.947-2.57-9.518-4.472-13.495c-0.899-1.879-1.872-3.585-2.906-5.123C229.919,16.586,237.143,23.23,241.499,31.6z M246,50 c0,3.888-0.568,7.644-1.607,11.2h-14.666c0.447-3.622,0.68-7.377,0.68-11.2c0-3.543-0.203-7.026-0.587-10.4h14.802 C245.515,42.918,246,46.403,246,50z M206,88.666c-5.315,0-11.044-7.451-14.127-19.466h28.255 C217.044,81.215,211.315,88.666,206,88.666z M190.332,61.2c-0.472-3.495-0.738-7.24-0.738-11.2c0-3.658,0.225-7.135,0.631-10.4 h31.549c0.406,3.265,0.631,6.742,0.631,10.4c0,3.96-0.266,7.705-0.738,11.2H190.332z M166,50c0-3.597,0.485-7.082,1.38-10.4h14.802 c-0.385,3.374-0.587,6.857-0.587,10.4c0,3.823,0.233,7.578,0.68,11.2h-14.666C166.568,57.644,166,53.888,166,50z M206,11.334 c5.431,0,11.292,7.785,14.323,20.266h-28.647C194.708,19.119,200.569,11.334,206,11.334z M190.868,12.981 c-1.034,1.539-2.007,3.244-2.906,5.123c-1.902,3.978-3.403,8.548-4.472,13.495h-12.989C174.857,23.23,182.081,16.586,190.868,12.981 z M170.921,69.2h12.74c1.056,4.641,2.501,8.932,4.301,12.695c0.899,1.879,1.872,3.585,2.906,5.123 C182.362,83.529,175.314,77.195,170.921,69.2z M221.132,87.019c1.034-1.539,2.007-3.244,2.906-5.123 c1.8-3.763,3.245-8.054,4.301-12.695h12.74C236.686,77.195,229.638,83.529,221.132,87.019z M31.002,145.014 c0-2.499,1.606-4.194,4.194-4.194s4.194,1.606,4.194,4.194V238h91.469v-92.986c0-2.499,1.606-4.194,4.194-4.194 c2.499,0,4.194,1.606,4.194,4.194V238h29.092V136.625c0-22.934-18.74-41.585-41.585-41.585h-8.388L85.17,154.336L53.401,95.04 h-9.816C20.651,95.04,2,113.78,2,136.625V238h29.092v-92.986H31.002z M86.474,83.69c-28.043,0-51.089-20.685-54.976-47.618 c0.555,1.249,1.527,2.082,2.499,3.054c6.108,6.108,16.243,6.108,22.351,0c0.972-0.972,1.805-2.082,2.499-3.054 c5.553-9.718,16.104-16.382,27.766-16.382c17.492,0,32.069,14.161,32.069,32.069S104.383,83.69,86.474,83.69z M73.17,107.04 c0-6.627,5.373-12,12-12s12,5.373,12,12s-5.373,12-12,12S73.17,113.668,73.17,107.04z" />
        </svg>
      break;
    case "CompetitivePricing":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-351 153 256 256"
          xmlSpace="preserve"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <path d="M-322.8 294.3c12 0 21.8-9.8 21.8-21.6 0-12-9.8-21.8-21.8-21.8s-21.8 9.8-21.8 21.8c.1 11.9 9.9 21.6 21.8 21.6zm0-40.4c10.3 0 18.7 8.4 18.7 18.7s-8.4 18.7-18.7 18.7c-10.3 0-18.7-8.4-18.7-18.7 0-10.3 8.4-18.7 18.7-18.7zm-6.7 28.2 7.7-8.5s.4-.6.3-1.1v-15.8s-.1-1.4-1.4-1.4-1.4 1.4-1.4 1.4v15.6l-7.4 8.1s-.8 1.1.1 1.9c1.1.7 2.1-.2 2.1-.2zm205.3-33.1 4.4-11.7H-141l3.7 11.7h13.1zm-6.2 47.3c12.7 0 23-10.3 23-23 0-8.9-5.1-16.7-12.4-20.5v-.1H-141v.1c-7.4 3.9-12.4 11.6-12.4 20.5 0 12.6 10.3 23 23 23zm-1.3-20.3c-3.4-1.1-5.8-2.8-5.8-5.9 0-2.9 2.1-5.1 5.5-5.8v-3h3.2v2.9c2.2.1 3.6.6 4.7 1.1l-1 3.6c-.8-.4-2.3-1.1-4.7-1.1-2.1 0-2.8 1-2.8 1.8 0 1.1 1.1 1.8 3.9 2.8 3.9 1.4 5.4 3.2 5.4 6.1 0 2.9-2.1 5.4-5.8 5.9v3.3h-3.2v-3c-2.2-.1-4.3-.7-5.5-1.4l1-3.7c1.4.7 3.3 1.4 5.4 1.4 1.8 0 3-.7 3-2.1.2-1.2-.8-2.1-3.3-2.9zm-92.3-24.3c15 0 27.1-12 27.1-27.1 0-15-12-27.1-27.1-27.1-15 0-27.1 12-27.1 27.1-.1 15.1 11.9 27.1 27.1 27.1zm112.4 78.6h-48.7c-3.9 0-8.5-1.4-11.3-5.5l-18.6-26.6-.1 60.2H-257l-.1-60.2-18.6 26.6c-2.8 4.1-7.4 5.5-11.3 5.5h-48.7c-15.8 0-16.7-24.1.3-24.1h42.1l24.4-35.5c7.2-9.8 15.3-14.5 26.8-14.5h36.1c11.6 0 19.7 4.3 26.8 14.5l24.4 35.5h42.4c16.9 0 15.8 24.1.8 24.1z" />
        </svg>
      break;
    case "ReliableService":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 256"
          xmlSpace="preserve"
          width={props.size}
          height={props.size}
          fill={props.fill}
        >
          <g />
          <path d="M224.7 71.6V22.7h-75.4v48.9H144v11.2h86.4V71.6h-5.7zM155.6 29h62.8v21.7h-20.6c-.5 0-.9.3-1 .8l-3 10.2-3-10.2c-.1-.5-.6-.8-1-.8h-4.1l-6-17.8c-.3-.9-1.8-.9-2.1 0l-6 17.8h-16V29zm62.8 40.5h-62.8V52.9h16.8c.5 0 .9-.3 1-.7l5.2-15.5 5.2 15.5c.1.4.6.7 1 .7h4.1l3.8 13c.1.5.6.8 1 .8.5 0 .9-.3 1-.8l3.8-13h19.8v16.6zM73.2 49.6c11 0 19.8-8.8 19.8-19.8S84.2 10 73.2 10s-19.8 8.8-19.8 19.8 8.8 19.8 19.8 19.8z" />
          <path d="M154.4 89.3h-31l-.9-1.3-16.9-24.7c-5.2-7.4-11.2-10.6-19.6-10.6H59.7c-8.4 0-14.4 3.4-19.6 10.6L23.4 87.8v50.4c0 4.7 4 8.7 8.7 8.7s8.7-4 8.7-8.7V94.9l8-11.4.2 151.3c0 7.2 5.1 10.9 10.3 11.2 5.8.3 11.9-3.5 11.8-11.6l.2-87.9h3.6l.2 87.9c0 7.8 5.7 11.6 11.3 11.6 5.5 0 10.9-3.8 10.9-11.2l.2-151.3 13.6 19.4c2 3 5.4 4 8.2 4h35.5c11.2 0 12-17.6-.4-17.6z" />
        </svg>
      break;
    case "England":
    case "en":
      iconsvg =
        <svg
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30"
          width={props.size}
          height={props.size}>
          <clipPath id="t">
            <path d="M25,15h25v15zv15h-25zh-25v-15zv-15h25z" />
          </clipPath>
          <path d="M0,0v30h50v-30z" fill="#012169" />
          <path d="M0,0 50,30M50,0 0,30" stroke="#fff" stroke-width="6" />
          <path d="M0,0 50,30M50,0 0,30" clip-path="url(#t)" stroke="#C8102E" stroke-width="4" />
          <path d="M-1 11h22v-12h8v12h22v8h-22v12h-8v-12h-22z" fill="#C8102E" stroke="#FFF" stroke-width="2" />
        </svg>
      break;
    case "Danmark":
    case "dk":
    case "Denmark":
      iconsvg =
        <svg xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 37 28"
          width={props.size}
          height={props.size}>
          <path fill="#c8102e" d="M0,0H37V28H0Z" />
          <path stroke="#fff" stroke-width="4" d="M0,14h37M14,0v28" />
        </svg>
      break;
    default:
      iconsvg =
        <svg xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width={props.size}
          height={props.size}>
        </svg>
  }
  return iconsvg;
}